import { useEffect, useMemo, useState } from "react";
import { approveAdminRewardProductsAPI, fetchAdminRewardProductsAPI } from "./rewardAPI";
import "./Reward.css";

// 관리자 > 기프티콘 상품(2026-10-04). 본사가 학생 상점에 올려도 되는 상품을 승인한다(화이트리스트).
// 승인을 끄면 그 상품은 모든 학원 상점에서 빠진다. 학원은 승인된 것 중에서 고른다.

const groupByBrand = (productList) => {
  const brandMap = new Map();
  productList.forEach((product) => {
    if (!brandMap.has(product.brand_name)) brandMap.set(product.brand_name, []);
    brandMap.get(product.brand_name).push(product);
  });
  return Array.from(brandMap.entries());
};

const AdminRewardProductPage = () => {
  const [productList, setProductList] = useState([]);
  const [isMock, setIsMock] = useState(false);
  const [keyword, setKeyword] = useState("");
  const [message, setMessage] = useState("");

  const load = (searchKeyword = "") =>
    fetchAdminRewardProductsAPI(searchKeyword)
      .then((data) => {
        setProductList(data.product_list);
        setIsMock(data.is_mock);
      })
      .catch(() => setMessage("상품을 불러오지 못했어요."));

  useEffect(() => {
    load();
  }, []);

  const brandList = useMemo(() => groupByBrand(productList), [productList]);
  const approvedCount = productList.filter((product) => product.is_hq_approved).length;

  const approve = async (idList, isApproved) => {
    try {
      await approveAdminRewardProductsAPI(idList, isApproved);
      await load(keyword);
    } catch {
      setMessage("저장하지 못했어요.");
    }
  };

  return (
    <div className="reward-page">
      <div className="reward-card">
        <div className="reward-card__title">
          기프티콘 상품 승인
          <span>
            {isMock && <span className="reward-badge reward-badge--mock">예시 상품</span>}{" "}
            <em>{approvedCount}개 승인</em>
          </span>
        </div>
        <form
          className="reward-search"
          onSubmit={(event) => {
            event.preventDefault();
            load(keyword);
          }}
        >
          <input value={keyword} onChange={(event) => setKeyword(event.target.value)} placeholder="상품명 · 브랜드" />
          <button type="submit" className="reward-button reward-button--ghost">
            찾기
          </button>
        </form>
        {message && <div className="reward-message">{message}</div>}
        {brandList.map(([brandName, list]) => {
          const isAllApproved = list.every((product) => product.is_hq_approved);
          return (
            <div className="reward-brand" key={brandName}>
              <div className="reward-brand__head">
                <b>{brandName}</b>
                <button type="button" onClick={() => approve(list.map((product) => product.id), !isAllApproved)}>
                  {isAllApproved ? "모두 승인 해제" : "모두 승인"}
                </button>
              </div>
              <div className="reward-product-grid">
                {list.map((product) => (
                  <button
                    type="button"
                    key={product.id}
                    className="reward-product"
                    aria-pressed={product.is_hq_approved}
                    onClick={() => approve([product.id], !product.is_hq_approved)}
                  >
                    <span className="reward-check">{product.is_hq_approved ? "✓" : ""}</span>
                    <span className="reward-product__name">{product.goods_name}</span>
                    <span className="reward-product__price">{product.sale_price.toLocaleString("ko-KR")}원</span>
                  </button>
                ))}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default AdminRewardProductPage;
